import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "vi", label: "Tiếng Việt", short: "VI" },
  { code: "zh", label: "简体中文", short: "简中" },
  { code: "zh-Hant", label: "繁體中文", short: "繁中" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent | TouchEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node))
        setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    document.addEventListener("touchstart", onClick);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("touchstart", onClick);
    };
  }, []);

  const current =
    LANGS.find((l) => i18n.language === l.code) ??
    LANGS.find((l) => i18n.language?.startsWith(l.code)) ??
    LANGS[0];

  const change = (code: string) => {
    i18n.changeLanguage(code);
    document.documentElement.lang = code;
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-label="Change language"
        className="flex items-center gap-1 text-xs tracking-widest uppercase text-foreground-800 cursor-pointer whitespace-nowrap hover:text-primary-600 transition-colors py-1"
      >
        <i className="ri-global-line text-base" />
        <span>{current.short}</span>
        <i className="ri-arrow-down-s-line" />
      </button>
      {open && (
        /* Căn left-0 top-full để bảng menu xổ gọn ngay dưới nút chọn ngôn ngữ, không đè lên menu trên */
        <ul className="absolute left-0 top-full mt-1 w-36 rounded-md border border-background-200 bg-background-50 py-1 shadow-lg z-[9999]">
          {LANGS.map((l) => (
            <li key={l.code}>
              <button
                type="button"
                onClick={() => change(l.code)}
                className={`w-full text-left px-4 py-2.5 text-xs tracking-wide cursor-pointer hover:bg-background-100 transition-colors ${current.code === l.code ? "text-primary-600 font-medium" : "text-foreground-800"}`}
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
